/*
 * 减免审核相关列表、操作、详情
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import {
  GetReduceListReq,
  SaveReduceReq,
  GetReduceDetailReq,
  GetReduceAuditListReq
} from "@/pbjs/xcommon/ticket_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
  OrderId?: string;
  CustomerId?: string;
  ApplyTimeRange?: string;
  TypeList?: number[];
  StatusList?: number[];
  Page: Page;
  WaitAudit: number,
  reduceid: number,
  ApprovedType:number,
  isRepay?:number
  AppName?: string;
}
// 设置减免列表请求体
export function setGetReduceListReq(arg: Options) {
  let request: any = new GetReduceListReq();
  request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
  request.setOrderid(arg.OrderId);
  request.setCustomerid(arg.CustomerId);
  request.setApplytimerange(arg.ApplyTimeRange);
  request.setTypeList(arg.TypeList);
  request.setStatusList(arg.StatusList);
  // request.setWaitaudit(arg.WaitAudit);
  request.setReduceid(Number(arg.reduceid));
  request.setApprovedtype(arg.ApprovedType);
  request.setIsrepay(arg.isRepay);
  request.setTabidx(Number(arg.WaitAudit));
  request.setAppname(arg.AppName)

  return request;
}
// 减免列表请求方法
export const getReduceListRequest = new InnerRequest(
  ticketClient,
  ticketClient.getReduceList
);

// 导出
export function getReduceListExcelReq(arg: Options) {
  let request: any = new GetReduceListReq();
  request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
  request.setOrderid(arg.OrderId);
  request.setCustomerid(arg.CustomerId);
  request.setApplytimerange(arg.ApplyTimeRange);
  request.setTypeList(arg.TypeList);
  request.setStatusList(arg.StatusList);
  return request;
}
export const getReduceListExcelRequest = new InnerRequest(
  ticketClient,
  ticketClient.getReduceListExcel
);
export interface SaveReduceReqOptions {
  Auditmark?: string;
  IsPassed?: boolean;
  // Id?: number;
  ReduceId?: number;

}
// 设置减免操作请求体
export function setSaveReduceReq(arg: SaveReduceReqOptions) {
  let request: any = new SaveReduceReq();
  // request.setId(arg.Id);
  request.setReduceid(arg.ReduceId);

  // request.setReducestatus(arg.Reducestatus);
  request.setIspassed(arg.IsPassed);
  request.setAuditmark(arg.Auditmark);
  return request;
}
// 减免操作请求方法
export const saveReduceRequest = new InnerRequest(
  ticketClient,
  ticketClient.saveReduce
);
export interface GetReduceDetailReqOptions {
  OrderId: number;
  reduceId?: number;
}
// 设置减免审核详情请求体
export function setGetReduceDetailReq(arg: GetReduceDetailReqOptions) {
  let request: any = new GetReduceDetailReq();
  request.setOrderid(arg.OrderId);
  return request;
}
// 减免审核详情请求方法
export const getReduceDetailRequest = new InnerRequest(
  ticketClient,
  ticketClient.getReduceDetail
);
export interface GetReduceDetailsReqOptions {
  OrderId: string;
  reduceId?: number;
}
// 设置审核详情请求体
export function setGetReduceAuditDetailReq(arg: GetReduceDetailsReqOptions) {
  let request: any = new GetReduceAuditListReq();
  request.setOrderid(arg.OrderId);
  request.setReduceid(Number(arg.reduceId))
  return request;
}
// 减免审核详情请求方法
export const getReduceDetailsRequest = new InnerRequest(
  ticketClient,
  ticketClient.getReduceAuditList
);

export interface ReduceDetailOption {
  OrderId: number;
  ReduceId: number
}
// 减免审核意见列表
export function setGetReduceAuditListReq(arg: ReduceDetailOption) {
  let request: any = new GetReduceAuditListReq();
  request.setOrderid(arg.OrderId);
  request.setReduceid(arg.ReduceId)
  return request;
}
//  减免审核意见列表 请求方法
export const GetReduceAuditListRequest = new InnerRequest(
  ticketClient,
  ticketClient.getReduceAuditList
);